import React from 'react'
import R from 'ramda'

class ImageWithLoaderAndDefault extends React.Component {
  constructor(props){
    super(props)
    this.state = {imgStatus: 'LOADING'}
    this.onLoad = this.onLoad.bind(this)
    this.onError = this.onError.bind(this)
  }
  shouldComponentUpdate(nextProps, nextState){
    return !R.equals(this.props, nextProps) || !R.equals(this.state, nextState)
  }
  onLoad(){
    this.setState({imgStatus: "LOADED"})
  }
  onError(){
    this.setState({imgStatus: "ERROR"})
  }
  currentUrl(){
    if(this.state.imgStatus === "ERROR"|| !this.props.imgSrc) {
      return this.props.defaultSrc
    }
    else return this.props.imgSrc
  }

  componentDidMount() {
        this.updateCanvas();
  }

  updateCanvas() {
        const currentUrl = this.currentUrl();  

        var image = new Image();
        image.src = currentUrl;
        image.className = "image-loader-done";

        const ctx = this.refs.canvas.getContext('2d');

        const cardHeight = 180;

        image.onload = function(){
            const imageWidth = image.naturalWidth;
            const imageHeight = image.naturalHeight;
            const startFromLeft = 0;
            const startFromTop = (imageHeight>cardHeight) ? (imageHeight-cardHeight)/2 : 0;     

            const imageWidthScaled = 384;
            const imageHeightScaled = (imageHeight)*(imageWidthScaled/imageWidth);


            ctx.drawImage(image,
                startFromLeft, startFromTop,
                imageWidth, imageHeight,
                0, 0,
                imageWidthScaled, imageHeightScaled);
        }
  }

  render(){

    {/*
    const currentUrl = this.currentUrl()
    if(this.state.imgStatus === "ERROR" || this.state.imgStatus == "LOADED"){
      return <img className="image-loader-done" src={currentUrl}/>
    }
    return <img className="image-loader" src={currentUrl} onLoad={this.onLoad} onError={this.onError}/>
    */}
    
    return <canvas ref="canvas" width='384px' height='180px'/>;

  }
}

ImageWithLoaderAndDefault.propTypes = {
  imgSrc: React.PropTypes.string,
  defaultSrc: React.PropTypes.string.isRequired,
}

export default ImageWithLoaderAndDefault



/** WEBPACK FOOTER **
 ** ./app/components/ImageWithLoaderAndDefault.jsx
 **/